import { gql } from '@apollo/client'
import { Button, Heading, NotificationIcon } from '@farol-ds/react'
import { extractCnjLawsuitNumber } from '@jusbrasil-web/shared-utils-cnj'

import { TERM_TYPE } from '../../../constants'
import { useMetrics } from '../../../hooks'
import { DocPopoverTermTrackerQuery } from './__generated__/doc-popover-term-tracker.graphql'
import styles from './styles.module.scss'

export type DocPopoverTermTrackerProps = {
  query: DocPopoverTermTrackerQuery
}

export function DocPopoverTermTracker(props: DocPopoverTermTrackerProps) {
  const {
    query: {
      root: { topics },
    },
  } = props
  const { title, tid, detectedEntityType, url, cnjNumber } = topics[0]
  const isLawsuitTopic = detectedEntityType === TERM_TYPE.Processo.toLowerCase()
  const termType = isLawsuitTopic ? TERM_TYPE.Processo : TERM_TYPE.Nome
  const { sendMetrics } = useMetrics<HTMLDivElement>()
  const getMonitorableTopicTitle = (isLawsuitTopic: boolean) => {
    if (isLawsuitTopic) {
      return extractCnjLawsuitNumber(title || '') || title
    }
    return title
  }
  const topicTitle = getMonitorableTopicTitle(isLawsuitTopic)
  const handleClick = () => {
    const eventName = isLawsuitTopic ? 'Diarios.MonitorProcessTopic' : 'Diarios.FollowNameClicked'
    const eventProperties = { from_component: 'MonitorablePopoverFooter' }
    sendMetrics(eventName, eventProperties)
  }

  const createAlertasUrl = (
    monitoredEntity: string,
    triggerName: string,
    type: string,
    refId: string
  ) => {
    const encodedMonitoredEntity = encodeURIComponent(monitoredEntity)
    const encodedTriggerName = encodeURIComponent(triggerName)
    const encodedType = encodeURIComponent(type)
    const encodedRefId = encodeURIComponent(refId)

    return `https://www.jusbrasil.com.br/alertas/novo?type=${encodedType}&filter=${encodedMonitoredEntity}&trigger=${encodedTriggerName}&refId=${encodedRefId}`
  }

  const getMonitoringUrl = (isLawsuitTopic: boolean) => {
    if (isLawsuitTopic) {
      const number = cnjNumber?.number || topicTitle
      return `${url}?topic-monitoring-flow=${number}`
    }

    return createAlertasUrl(title || '', 'alert-button', 'TOPIC', tid.toString())
  }

  return (
    <div className={styles.termTracker}>
      <Heading size="sm">{topicTitle}</Heading>
      <p>
        Seja notificado sempre que &quot;<strong>{title}</strong>&quot; for citado em mais de 400
        Diários Oficiais de todo o Brasil.
      </p>
      <Button
        className={styles.termTrackerButton}
        kind="primary"
        onClick={handleClick}
        leftIcon={<NotificationIcon />}
        asChild
      >
        <a
          href={getMonitoringUrl(isLawsuitTopic)}
          target="_blank"
          rel="noopener noreferrer"
        >{`Acompanhar ${termType}`}</a>
      </Button>
    </div>
  )
}

DocPopoverTermTracker.query = gql`
  query DocPopoverTermTracker($tidList: [Int!]!) {
    root {
      topics: topicsByIds(tidList: $tidList) {
        tid
        title
        detectedEntityType
        url
        cnjNumber {
          number
        }
      }
    }
  }
`
